<div
    class="page"
    *ngIf="testSessionInformation$ | async as testSessionInformation"
>
    <app-step-progress [steps]="steps"></app-step-progress>
    <div>
        <app-proof-of-identity-selection-summary
            [testSession]="testSessionInformation$ | async"
            [nextStep]="nextStep"
        ></app-proof-of-identity-selection-summary>
        <br />
        <app-page-title [title]="'Recommended study materials'"></app-page-title>
        <br />
        <h5 style="text-transform: none;">Top 3 study materials:</h5>
        <div class="row">
            <div
                *ngFor="let product of topProducts"
                class="col-md-4 my-5"
            >
                <div class="card text-center h-100">
                    <img
                        class="
                    card-img-top
                    mx-auto
                    d-block"
                        [src]="product.imageUrl"
                        alt="product-image"
                    >
                    <div class="card-body">
                        <div class="card-title">
                            <a (click)="onModalLoad(product.id)">{{product.name}}</a>
                        </div>
                        <p class="product-type">{{product.productTypeName}}</p>
                        <div
                            *ngIf="product.listPrice > 0 && product.isPurchasable"
                            class="text-center"
                        >
                            <app-product-price [product]="product"></app-product-price>
                        </div>
                        <br />
                    </div>
                    <div class="card-btn w-100">
                        <button
                            *ngIf="product.isPurchasable"
                            (click)="onAdd(product)"
                            type="button"
                            class="btn btn-primary"
                        >
                            Add To Cart
                        </button>
                        <button
                            *ngIf="!product.isPurchasable"
                            (click)="onModalLoad(product.id)"
                            type="button"
                            class="btn btn-primary"
                        >
                          Read More
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <br />
        <div class="col-md-6 text-center mx-auto">
            <a routerLink="/product-shopping">Click here to shop for more study materials</a>
            <br />
            <br />
            <button
                type="button"
                (click)="redirectNextStep()"
                class="btn btn-primary my-3"
            >Review Order & Pay</button>
        </div>
    </div>
</div>
<app-modal
    #addItemWarning
    title="Note"
    [body]="addItemWarningMesssage"
    (clickPositive)="finalizeAdd()"
    isConfirm="true"
>
</app-modal>
